<template>
<section class="row clearfix">
    <div class="col-md-12">
        <div class="modal fade" id="reportModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" v-show="editMode">Edit Report</h4>
                        <h4 class="modal-title" v-show="!editMode">New Report</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <EServiceRadFormReport :editMode="editMode" :report="report" :findings="findings" :patient="report.patient" :appointment="appointment" :service="report.service"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Report Detail</h3>
                <div class="card-tools">
                    <button v-if="report.report == null" class="btn btn-sm btn-primary" @click="addReport"><i class="fa fa-edit"></i> Write Report</button>
                    <button v-else="report.report != null" class="btn btn-sm btn-warning" @click="editReport"><i class="fa fa-edit"></i> Update Report</button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">    
                    <div class="col-12 col-md-12 col-lg-8 order-2 order-md-1" v-if="report != null && report.service != null">
                        <h4>Recent Activity</h4>
                        <div class="timeline">
                            <div v-if="report.radiologist != null && report.radiologist_id != null">
                                <i class="fas fa-file bg-purple"></i>
                                <div class="timeline-item">
                                    <span class="time"><i class="fas fa-clock"></i> {{report.report.created_at | excelDate}}</span>
                                    <h3 class="timeline-header"><b>Radiologist Report</b></h3>
                                    <div class="timeline-body row">
                                        <div class="user-block col-md-12">
                                            <img class="img-circle img-bordered-sm" :src="report.radiologist != null ? '/img/profile/'+report.radiologist.image : '/img/profile/default.png'" :title="report.radiologist.first_name+' '+report.radiologist.last_name">
                                            <span class="username"><a href="#">{{report.radiologist != null ? report.radiologist.first_name+' '+report.radiologist.last_name : 'Radiologist Undefined'}}</a></span>
                                            <span class="description">Posted: {{report.report.created_at | excelDate}}</span>
                                        </div>
                                    
                                        <p class="col-md-12"><strong>{{ report.report.summary | firstUp }}</strong></p>
                                        <p class="col-md-12" v-html="report.report.details"></p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="report.medical_officer != null && report.doctor_id != null && report.consultation != null">
                                <i class="fas fa-user-md bg-green"></i>
                                <div class="timeline-item">
                                    <span class="time"><i class="fas fa-clock"></i> {{report.consultation.created_at | excelDate}}</span>
                                    <h3 class="timeline-header"><b>Medical Officer</b></h3>
                                    <div class="timeline-body row">
                                        <div class="user-block col-md-12">
                                            <img class="img-circle img-bordered-sm" :src="report.medical_officer != null && report.medical_officer.image != null ? '/img/profile/'+report.medical_officer.image : '/img/profile/default.png'" alt="user image">
                                            <span class="username"><a href="#">{{report.medical_officer | fullName}}</a>
                                            </span>
                                            <span class="description">Posted: {{report.consultation.created_at | excelDate}}</span>
                                        </div>
                                        <br />
                                        <p class="col-md-12">{{ report.consultation.decision == 6 ? "Send to Xray for CXR": (report.consultation.decision == 7 ? "Send to Lab for Sputum": (report.consultation.decision == 8 ? "Kid under 11years": (report.consultation.decision == 10 ? "Patient Psotpoed": "Patient Cancelled"))) }}</p>
                                        <p class="col-md-12" v-html="report.consultation.remarks"></p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="report.xray_officer_id != null && report.xray_officer != null">
                                <i class="fas fa-x-ray bg-blue"></i>
                                <div class="timeline-item">
                                    <span class="time"><i class="fas fa-clock"></i> {{report.consultation.created_at | excelDate}}</span>
                                    <h3 class="timeline-header"><b>Xray</b></h3>
                                    <div class="timeline-body row">
                                        <div class="user-block col-md-12">
                                            <img class="img-circle img-bordered-sm" :src="report.xray_officer != null && report.xray_officer.image != null ? '/img/profile/'+report.xray_officer.image : '/img/profile/default.png'" alt="user image">
                                            <span class="username"><a href="#">{{report.xray_officer | fullName}}</a>
                                            </span>
                                            <span class="description">Posted: {{report.xray_at | excelDate}}</span>
                                        </div>
                                        <br />
                                        <p class="col-md-12">{{ report.consultation.decision == 6 ? "Send to Xray for CXR": (report.consultation.decision == 7 ? "Send to Lab for Sputum": (report.consultation.decision == 8 ? "Kid under 11years": (report.consultation.decision == 10 ? "Patient Psotpoed": "Patient Cancelled"))) }}</p>
                                        <p class="col-md-12" v-html="report.consultation.remarks"></p>
                                    </div>
                                </div>
                            </div>
                            <div  v-if="report.front_office_id != null">
                                <i class="fas fa-hospital-user bg-blue"></i>
                                <div class="timeline-item">
                                    <span class="time"><i class="fas fa-clock"></i> {{report.arrived_at | excelDate}}</span>
                                    <h3 class="timeline-header"><b>Front Officer</b></h3>
                                    <div class="timeline-body row">
                                        <div class="user-block col-md-12">
                                            <img class="img-circle img-bordered-sm" :src="report.front_officer != null ? '/img/profile/'+report.front_officer.image : '/img/profile/default.png'" :title="report.front_officer != null ? report.front_officer.first_name+' '+report.front_officer.last_name : 'Undefined Officer'">
                                            <span class="username"><a href="#">{{report.front_officer | fullName}}</a>
                                            </span>
                                            <span class="description">Posted: {{report.arrived_at | excelDate}}</span>
                                        </div>
                                        <br />
                                        <p class="col-md-12" v-html="report.front_office_remark"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-4 order-1 order-md-2 card">
                        <div class="card-header">
                            <h6 class="card-title"><i class="fas fa-user"></i> Applicant Detail</h6>
                        </div>
                        <div class="card-body">
                            <div class="text-muted">
                                <img :src="(report.patient != null && report.patient.image != null) ? '/img/applicants/'+report.patient.image : '/img/profile/default.png'" class="img-fluid" :title="report.patient.last_name+' '+report.patient.first_name+' '+report.patient.middle_name" />
                                <p class="text-sm">Surname | First Name Other Name: <b class="d-block">{{report.patient.last_name}} | {{report.patient.first_name}} {{report.patient.middle_name}}</b></p>
                                <p class="text-sm">Sex | Age: <b class="d-block">{{report.patient.sex}} | {{report.patient.dob | age}} years</b></p>
                                <p class="text-sm">Nationality: <b class="d-block">{{report.patient.nationality != null && report.patient.nationality_id != null ? report.patient.nationality.name : 'None Given'}}</b></p>
                                <p class="text-sm">Passport No. | Visa Type: <b class="d-block">{{report.patient.passport_no != null ? report.patient.passport_no :'Request Passport' }} | {{report.patient.visa_type != null ? report.patient.visa_type :'Request Visa Type' }}</b></p>
                                <p class="text-sm">Registered at: <b class="d-block">{{report.patient.created_at | excelDate}}</b></p>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    data(){
        return {
            editMode: false,
            report: {}, 
            report: {},
            findings: [],    
        }
    },
    methods:{
        addReport(){
            this.editMode = false;
            Fire.$emit('reportDataFill', this.report);
            $('#reportModal').modal('show');
            this.$Progress.finish();
        },
        editReport(){
            this.$Progress.start();
            this.editMode = true;
            Fire.$emit('reportDataFill', this.report);
            $('#reportModal').modal('show');
            this.$Progress.finish();
        },
        getAllInitials(){
            this.$Progress.start();
            axios.get('/api/emr/radiologists/'+this.$route.params.id)
            .then(response =>{
                this.reportReload(response);
                this.$Progress.finish();
                toast.fire({icon: 'success', title: 'Report was loaded successfully',});
            })
            .catch(()=>{
                this.$Progress.fail();
                toast.fire({icon: 'error', title: 'Report was not loaded successfully',})
            });
        },
        reportReload(response){
            this.findings = response.data.findings;
            this.report = response.data.report;
        },
    },
    mounted() {
        this.getAllInitials();    
        Fire.$on('reportReload', response=>{
            this.reportReload(response);
            $('#reportModal').modal('hide');
        });    
    }
}
</script>